import { useState, createContext, useEffect } from 'react'
import { useLocation } from 'react-router'

interface ITable {
  children: React.ReactNode
}
interface IData {
  salesChannel?: string
  typeEvaluation?: string
  yearModel: any
  id: string
  code: string
  codigo?: string
  lastChange: string
  situacao?: string
  active?: string
  user: string
  estimatedValue?: string
  measurement?: string
  category?: string
  categoryInspection?: string
  sla?: string
  breakdown?: string
  provider?: string
  type?: string
  value?: any
  name?: string
  brand?: string
  nameService?: string
  cep?: string
  cnpj?: string
  corporate?: string
  contact?: string
  email?: string
  number?: string
  social?: string
  fantasyName?: string
  cpf?: string
  uf?: string
  city?: string
  district?: string
  street?: string
  complement?: string
  cityId?: string
  situationId?: number
  plate?: string
  hiddenpermissionRoles?: any
  placa?: string
  stateRegistration?: string
  hiddenFipe?: any
  hiddenModelId?: any
  hiddenEvaluationEnum?: any
  idSurvey?: string
  dataInicio?: any
  dataConclusao?: any
  dataPrevistaConclusao?: any
  dataEnvioPrestador?: any
  codigoOM?: string
  tipoAvaliacao?: string
  vistoriaId?: string
  valuationCompany?: []
  types?: []
  prestador?: string
  situation?: string
  reasonInactivation?: string
  typeSurvey?: string
  inspectionCode?: string
  categoryId?: string
  precificationValue?: number
  observacaoImplemento?: string
  typeVehicle?: string
  tipoVeiculo?: string
  observation?: string
  vehicleStatus?: string
  residualValue?: number
  nome?: string
  tipo?: string
  status?: string
  statusVeiculo?: string
  minValue?: number
  maxValue?: number
  mediumValue?: number
  empresaAvaliadoraId?: string
  situacaoNegociacao?: number
  precificationPercent?: number
}

interface ITableDataContext {
  ROW_DATA: IData | undefined
  SET_ROW_DATA: (data?: IData) => void
  CHECK_SELECTS: any
  SET_CHECK_SELECTS: (data?: any) => void
  CLEAR_DATA: () => void
  CLEAR_CHECK_SELECTS: () => void
  PER_PAGE: number
  SET_PER_PAGE: (page: number) => void
  CURRENTE_PAGE: number
  SET_CURRENT_PAGE: (page: number) => void
  SET_ACTUAL_COMPONENT: (value: string) => void
  ACTUAL_COMPONENT: string
  SORT_FIELD: string
  SET_SORT_FIELD: (sortField: string) => void
  SET_QUANTITY_REGISTERS: (value: number) => void
  SORT_ASCENDING: boolean
  SET_SORT_ASCENDING: any
  PAGINATION_AND_ORDINATION: any
  CLEAR_PAGINATION_AND_ORDINATION: () => void
}

export const TableDataContext = createContext<ITableDataContext>({
  ROW_DATA: undefined,
  SET_ROW_DATA: (data?: IData) => null,
  CHECK_SELECTS: undefined,
  SET_CHECK_SELECTS: (data?: any) => null,
  CLEAR_DATA: () => null,
  CLEAR_CHECK_SELECTS: () => null,
  PER_PAGE: 0,
  SET_PER_PAGE: () => {},
  CURRENTE_PAGE: 0,
  SET_CURRENT_PAGE: () => {},
  SET_ACTUAL_COMPONENT: () => {},
  ACTUAL_COMPONENT: '',
  SORT_FIELD: '',
  SET_SORT_FIELD: () => {},
  SORT_ASCENDING: true,
  SET_SORT_ASCENDING: () => {},
  PAGINATION_AND_ORDINATION: {},
  SET_QUANTITY_REGISTERS: () => {},
  CLEAR_PAGINATION_AND_ORDINATION: () => {}
})

export function TableDataProvider({ children }: ITable) {
  const { pathname } = useLocation()
  const [ROW_DATA, SET_ROW_DATA] = useState<IData>()
  const [PER_PAGE, SET_PER_PAGE] = useState(10)
  const [CHECK_SELECTS, SET_CHECK_SELECTS] = useState<any>([])
  const [CURRENTE_PAGE, SET_CURRENT_PAGE] = useState(1)
  const [ACTUAL_COMPONENT, SET_ACTUAL_COMPONENT] = useState('')
  const [QUANTITY_REGISTERS, SET_QUANTITY_REGISTERS] = useState<number>(10)
  const [SORT_FIELD, SET_SORT_FIELD] = useState('')
  const [SORT_ASCENDING, SET_SORT_ASCENDING] = useState<any>(null)
  const PAGINATION_AND_ORDINATION = {
    Page: CURRENTE_PAGE,
    PageSize: PER_PAGE,
    SortField: SORT_FIELD,
    SortAscending: SORT_ASCENDING
  }

  function CLEAR_DATA() {
    SET_ROW_DATA(undefined)
  }

  function arrOfCheckbox() {
    return [...new Array(PER_PAGE)].map(() => ({
      checked: false,
      id: '',
      row: null
    }))
  }

  // Adicionado para contornar endpoints sem paginação (usuários)
  useEffect(() => {
    const registers = [...new Array(QUANTITY_REGISTERS)].map(() => ({
      checked: false,
      id: '',
      row: null
    }))
    SET_CHECK_SELECTS(registers)
  }, [QUANTITY_REGISTERS])

  function CLEAR_CHECK_SELECTS() {
    SET_CHECK_SELECTS(arrOfCheckbox)
  }

  function CLEAR_PAGINATION_AND_ORDINATION() {
    if (PER_PAGE !== 10) SET_PER_PAGE(10)
    if (SORT_FIELD !== '') SET_SORT_FIELD('')
    if (CURRENTE_PAGE !== 1) SET_CURRENT_PAGE(1)
    if (!SORT_ASCENDING) SET_SORT_ASCENDING(true)
  }

  useEffect(() => {
    SET_CHECK_SELECTS(arrOfCheckbox)
  }, [PER_PAGE, CURRENTE_PAGE])

  useEffect(() => {
    CLEAR_PAGINATION_AND_ORDINATION()
  }, [pathname])

  return (
    <TableDataContext.Provider
      value={{
        SET_ROW_DATA,
        ROW_DATA,
        CLEAR_DATA,
        PER_PAGE,
        SET_PER_PAGE,
        CURRENTE_PAGE,
        SET_CURRENT_PAGE,
        CHECK_SELECTS,
        SET_CHECK_SELECTS,
        CLEAR_CHECK_SELECTS,
        SET_ACTUAL_COMPONENT,
        ACTUAL_COMPONENT,
        SET_SORT_FIELD,
        SET_QUANTITY_REGISTERS,
        SORT_FIELD,
        SORT_ASCENDING,
        SET_SORT_ASCENDING,
        PAGINATION_AND_ORDINATION,
        CLEAR_PAGINATION_AND_ORDINATION
      }}
    >
      {children}
    </TableDataContext.Provider>
  )
}
